module.exports = __webpack_public_path__ + "static/mid-card-646131db82d9e1855fdd93d7986ffb1d.png";